import { Nlu } from '@onereach/sdk'
import config from '../config'
import store from '../store/index'
import _get from 'lodash/get'

export default new Nlu({
  nluApiUrl: config.NLU_API_URL,
  userTokenFactory: () => _get(store, 'state.auth.token')
})
